import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const ModalWrapper = ({
  title,
  content,
  footer,
  className,
  id,
  showFooter,
  showCancel,
  showConfirm,
  showClose,
  disableConfirm,
  btnConfirmTitle,
  btnConfirmClass,
  btnCancelTitle,
  btnCancelClass,
  onConfirm,
  onCancel }) => (
    <React.Fragment>
      <div className="modal">
        <div className="modal-overlay" />
        <div className={ `modal-container${ className ? ` ${ className }` : '' }` }>
          <div className="modal-content">
            <div className="modal-header">
              { showClose && <button className="modal-close-button" type="button" onClick={ () => onCancel() } onKeyDown={ () => onCancel() }>
                <FontAwesomeIcon
                  icon="times"
                  className="icon"
                />
              </button> }
              <div id={ id ? `${ id }-title` : '' } className="modal-title">{ title }</div>
            </div>
            <div className="modal-body">
              <div id={ id ? `${ id }-content` : '' } className="content">
                { content }
              </div>
            </div>
            { showFooter && <div className="modal-footer">
              <div className="footer">
                { footer }
              </div>
              <div className="row modal-buttons">
                { showCancel
                && <div className="col-6">
                  { showCancel && <button
                    type="button"
                    className={ `btn ${ btnCancelClass }` }
                    onClick={ () => onCancel() }
                  >{ btnCancelTitle }</button> }
                </div> }

                <div className={ showCancel ? 'col-6' : 'col-12' }>
                  { showConfirm && <button
                    type="submit"
                    disabled={ disableConfirm }
                    className={ `btn ${ btnConfirmClass }` }
                    onClick={ () => onConfirm() }
                    id={ id ? `${ id }-confirm-btn` : '' }
                  >
                    { btnConfirmTitle }
                  </button> }
                </div>

              </div>
            </div> }
          </div>
        </div>
      </div>
    </React.Fragment>
);

ModalWrapper.propTypes = {
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  content: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  footer: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node
  ]),
  className: PropTypes.string,
  showFooter: PropTypes.bool,
  showCancel: PropTypes.bool,
  showConfirm: PropTypes.bool,
  showClose: PropTypes.bool,
  disableConfirm: PropTypes.bool,
  btnConfirmTitle: PropTypes.string,
  btnConfirmClass: PropTypes.string,
  btnCancelTitle: PropTypes.string,
  btnCancelClass: PropTypes.string,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  id: PropTypes.string,
};

ModalWrapper.defaultProps = {
  title: 'Title',
  content: null,
  footer: '',
  className: null,
  id: null,
  showFooter: true,
  showCancel: true,
  showConfirm: true,
  showClose: true,
  disableConfirm: true,
  btnConfirmTitle: 'Continue',
  btnConfirmClass: 'btn-primary',
  btnCancelTitle: 'Return',
  btnCancelClass: 'btn-secondary',
  onConfirm: () => {},
  onCancel: () => {},
};

export default ModalWrapper;
